import cx from 'classnames';
import PropTypes from 'prop-types';

import * as style from './heading.module.scss';

const Heading = ({ as: As, children, className, id, size }) => {
  // "as" is what structural type it should be
  // "size" is if it should be styled differently than that
  // Deviations from this being consistent would be driven by visuals
  // that are sub-optimal when rendered as it's natural, structural type
  const styleSize = size ? size : As;
  return (
    <As className={cx(style.heading, style[styleSize], className)} id={id}>
      {children}
    </As>
  );
};

Heading.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.oneOf(['h0', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};

export default Heading;
